
// Función para validar contraseñas
export const validatePassword = (password: string): { isValid: boolean; errors: string[] } => {
  const errors: string[] = [];
  
  if (password.length < 8) {
    errors.push("La contraseña debe tener al menos 8 caracteres");
  }
  
  if (!/[A-Z]/.test(password)) {
    errors.push("La contraseña debe incluir al menos una letra mayúscula");
  }

  // Simbolos sin escapes innecesarios
  if (!/[-!@#$%^&*()_+={}[\]:'"\\|,.<>/?]/.test(password)) {
    errors.push("La contraseña debe incluir al menos un símbolo");
  }

  if (!/[0-9]/.test(password)) {
    errors.push("La contraseña debe incluir al menos un número");
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
};